import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { VenueSummary } from '../../components/VenueSummary';

export class VenuesIngroup extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.pageKey = 'VenuesIngroup'
    this.pageTitle = Helper.getString('venues')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.venueGroupId = this.props.match.params.id
    this.uploadLocation = this.orgId
    this.sitesById = {}
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('venuegroups'), to: this.baseRoute() + '/venuegroups' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['venuegroups', this.venueGroupId] },
      { method: 'GET', paths: ['miscs', 'venues-of-group'], queryParams: { venueGroupId: this.venueGroupId }},
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => this.renderVenueInfo(current),
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.orgId
    }
    this.noTableHead = true
    this.noAdd = true
  }

  onFetchSuccess(results) {
    this.pageTitle = results[0].title
    this.sitesById = results[1].sitesById || {}
    const items = results[1].items || []
    items.forEach(item => {
      if (item.orgId && this.sitesById[item.orgId]) item.siteInfo = { ...this.sitesById[item.orgId] }
    })
    this.setState({
      items
    })
  }

  renderVenueInfo(current) {
    const site = current.site || current.siteInfo || (current.orgId && this.sitesById[current.orgId])
    return (
      <VenueSummary item={current} site={site} showNotRegistered={false} />
    )
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions(current) {
    const actions = []
    return actions
  }
}

const Styles = StyleSheet.create({
  storeNameText:{
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/VenuesIngroup.js